import { createContext, useContext, useState } from 'react';

export enum WIDGETS {
  CHAT = 'chat',
  HELP = 'help',
  ONBOARDING = 'onboarding',
}

type WidgetType = WIDGETS | null;
type WidgetContextType = {
  widget: WidgetType;
  setWidget: (v: WidgetType) => void;
  toggleWidget: (v: WidgetType) => void;
};

const WidgetContext = createContext<WidgetContextType>({
  widget: null,
  setWidget: () => {}, // eslint-disable-line @typescript-eslint/no-empty-function
  toggleWidget: () => {}, // eslint-disable-line @typescript-eslint/no-empty-function
});

export const WidgetContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [widget, setWidget] = useState<WidgetType>(null);

  const toggleWidget = (newState: WidgetType) => {
    if (newState === widget) {
      setWidget(null);
    } else {
      setWidget(newState);
    }
  };

  return (
    <WidgetContext.Provider value={{ widget, setWidget, toggleWidget }}>
      {children}
    </WidgetContext.Provider>
  );
};

export const useWidget = () => useContext(WidgetContext);
